import { render, staticRenderFns } from "./TbButton.vue?vue&type=template&id=0125262e"
import script from "./TbButton.vue?vue&type=script&lang=ts"
export * from "./TbButton.vue?vue&type=script&lang=ts"
import style0 from "./TbButton.vue?vue&type=style&index=0&id=0125262e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports